import React from 'react';
import glamorous from 'glamorous';
import PropTypes from 'prop-types';
import Link from 'redux-first-router-link';

import Logo from '../../../assets/Logo';
import { media, mixins } from '../../../styles';

import Title from '../../typography/Title';
import Headline from '../../typography/Headline';

import EventCalendar from './EventCalendar';

const MobileViewContainer = glamorous.div({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,

  [media('sm', { isMax: true })]: {
    justifyContent: 'center',
    width: 'calc(100% - 58px)',
    height: 56,
  },
});

const Row = glamorous.div(props => ({
  display: 'flex',
  flexDirection: 'row',

  padding: 8,

  [media('sm', { isMax: true })]: {
    zIndex: 100,
    backgroundColor: props.theme.primary.base,
    color: '#fff',
    padding: '1px 0 0 0',
    alignItems: 'center',
  },

  [media('sm')]: {
    flexDirection: 'row',

    paddingTop: 32,
    paddingBottom: 32,
  },

  [media('md')]: {
    paddingLeft: 0,
    paddingRight: 0,
  },
}));

const CalendarRow = glamorous.div({
  display: 'none',
  flexDirection: 'row',
  flexShrink: 0,
  alignItems: 'flex-end',
  justifyContent: 'space-between',

  [media('sm')]: {
    display: 'flex',
    alignSelf: 'flex-start',
  },
});

const styleTitle = {
  marginTop: 0,
  marginBottom: 16,

  [media('lg')]: {
    marginBottom: 5,
  },

  [media('sm', { isMax: true })]: {
    fontSize: '0.9em',
    marginBottom: 4,

    ...mixins.textOverflowEllipsis,
  },
};

const styleHeadline = {
  margin: 0,

  [media('sm', { isMax: true })]: {
    flex: 2,
    minWidth: 0,
    fontSize: '0.75em',
    lineHeight: '1.2em',
    marginBottom: 4,

    '& > div': {
      ...mixins.textOverflowEllipsis,
    },
  },
};

const EventDate = glamorous.div({
  overflow: 'hidden',
  width: 100,
  marginRight: 8,
  textAlign: 'right',

  fontSize: '0.75em',
  lineHeight: '1.2em',
  whiteSpace: 'nowrap',

  [media('xs')]: {
    width: 'auto',
  },

  [media('sm')]: {
    display: 'none',
  },
});

const LogoContainer = glamorous.div({
  display: 'flex',
  alignItems: 'stretch',
  justifyContent: 'center',
  alignSelf: 'stretch',

  [media('sm')]: {
    display: 'none',
  },
});

const Col = glamorous.div({
  [media('sm', { isMax: true })]: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',

    width: '100%',

    '& h4': {
      marginBottom: 0,
      marginRight: 8,
    },
  },
})

const HideXs = glamorous.span({
  [media('xs', { isMax: true })]: {
    display: 'none',
  },
});

class EventHeader extends React.PureComponent {
  static propTypes = {
    city: PropTypes.string,
    date: PropTypes.instanceOf(Date),
    dateTime: PropTypes.object,
    name: PropTypes.string,
    stateProvince: PropTypes.string,
    venue: PropTypes.string,
  };

  static defaultProps = {
    city: '',
    date: null,
    dateTime: {},
    name: '',
    stateProvince: '',
    venue: '',
  };

  get day() {
    const { date } = this.props;

    return date ? date.getDate() : 1;
  }

  render() {
    const {
      city,
      dateTime,
      name,
      stateProvince,
      venue,
      innerRef,
    } = this.props;

    return (
      <Row innerRef={innerRef}>
        <LogoContainer>
          <Link to="/" style={{lineHeight: '48px'}}>
            <Logo
              isIcon
              white
              style={{
                height: 32,
                marginLeft: 16,
                marginRight: 16,
              }}
            />
          </Link>
        </LogoContainer>
        <CalendarRow>
          <EventCalendar
            day={this.day}
            month={dateTime.month}
            time={dateTime.time}
          />
        </CalendarRow>
        <MobileViewContainer>
          <Title style={styleTitle}>
            {name}
          </Title>

          <Col>
            <Headline
              style={styleHeadline}
              weight={200}>
              <div>{venue}, {city}, {stateProvince}</div>
            </Headline>

            <EventDate>
              <div>
                <HideXs>{dateTime.day},&nbsp;</HideXs>
                {dateTime.month} {this.day} @ {dateTime.time}
              </div>
            </EventDate>
          </Col>
        </MobileViewContainer>
      </Row>
    );
  }
}

export default EventHeader;



// WEBPACK FOOTER //
// ./src/components/features/Event/EventHeader.js